import Form from 'react-bootstrap/Form';
import React, {useEffect, useState} from 'react';

export default function TutorSearch(props) {
    const {
        countries
    } = props

    const initialCountry = countries.find((country) => country.name === "United States of America") || countries[0]

    const [selectedCountry, setSelectedCountry] = React.useState(initialCountry)
    const [selectedRegion, setSelectedRegion] = React.useState(null)
    const [selectedCity, setSelectedCity] = React.useState(null)
    const [selectedType, setSelectedType] = React.useState(null)

    function changeCountryHandler(event) {
        setSelectedCountry(countries.find((country) => country.id === event.target.value))
        setSelectedRegion(null)
        setSelectedCity(null)
    }
    function changeRegionHandler(event) {
        setSelectedRegion(selectedCountry.regions.find((region) => region.id === event.target.value))
        setSelectedCity(null)
    }
    function changeCityHandler(event) {
        setSelectedCity(selectedRegion.cities.find((city) => city.id === event.target.value))
    }
    function changeTypeHandler(event) {
        setSelectedType(event.target.value)
    }


    return (
        <div>
            <Form.Label>Country</Form.Label>
            <Form.Select className={"search-field"} onChange={changeCountryHandler} defaultValue={initialCountry.id}>
                {countries.map((country) => (
                    <option value={country.id}>{country.name}</option>
                ))}
            </Form.Select>
            <Form.Label>Region</Form.Label>
            <Form.Select className={"search-field"} onChange={changeRegionHandler}>
                <option>Any</option>
                {
                    selectedCountry ? selectedCountry.regions.map((region) => (
                        <option value={region.id}>{region.name}</option>
                    )) : null
                }
            </Form.Select>
            <Form.Label>City</Form.Label>
            <Form.Select className={"search-field"} onChange={changeCityHandler}>
                <option>Any</option>
                {
                    selectedRegion ? selectedRegion.cities.map((city) => (
                        <option value={city.id}>{city.name}</option>
                    )) : null
                }
            </Form.Select>
            <Form.Label>Availability</Form.Label>
            <Form.Select className="search-field" onChange={changeTypeHandler}>
                <option value="">Any</option>
                <option value="online">Online</option>
                <option value="private">Private</option>
            </Form.Select>

            <input type="hidden" name="country" value={selectedCountry ? selectedCountry.id : null}/>
            <input type="hidden" name="region" value={selectedRegion ? selectedRegion.id : null}/>
            <input type="hidden" name="city" value={selectedCity ? selectedCity.id : null}/>
            <input type="hidden" name="type" value={selectedType ? selectedType : null}/>
            <button type="submit" className={"btn btn-primary"}>Search</button>
        </div>
    );
}

    import { render } from 'react-dom'                                    
    if (window.reactComponents === undefined) {                           
      window.reactComponents = {}                                         
    }                                                                     
    window.reactComponents.TutorSearch = (function() {                   
    let _args = {}                                                        
                                                                          
    return {                                                              
      init: function (Args) {                                             
        _args = Args                                                      
      },                                                                  
      render: function () {                                               
        const  { id, ...props } = JSON.parse(_args)                       
        render(<TutorSearch {...props}/>, document.getElementById(id))   
      }                                                                   
    }                                                                     
  }())